import script from "./OrgOrderProject.vue?vue&type=script&setup=true&lang=ts"
export * from "./OrgOrderProject.vue?vue&type=script&setup=true&lang=ts"

import "./OrgOrderProject.vue?vue&type=style&index=0&id=2808d16e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2808d16e"]])

export default __exports__